import { statusSchema } from '@billing/validation/status';
import { CLAIM_TARIFF_STATUS } from '@billing/validation/tariff';

export interface Status {
  id: string;
  type: string;
  description: string;
}

// TODO(claim-status-migration-cleanup): Deprecated - use tariff-derived claim behavior and validation status unions.
// Retained for compatibility with legacy tests and mappings.
export const ClaimStatusEnum = {
  incomplete: CLAIM_TARIFF_STATUS.INCOMPLETE,
  ready: CLAIM_TARIFF_STATUS.READY,
  submitted: CLAIM_TARIFF_STATUS.SUBMITTED,
  cancelled: CLAIM_TARIFF_STATUS.CANCELLED,
  pending: CLAIM_TARIFF_STATUS.PENDING,
  error: 'Error',
  paid: CLAIM_TARIFF_STATUS.PAID,
  queried: CLAIM_TARIFF_STATUS.QUERIED,
  uninsured: CLAIM_TARIFF_STATUS.UNINSURED,
  invoiced: CLAIM_TARIFF_STATUS.PAYOR_INVOICED,
  reverted: CLAIM_TARIFF_STATUS.REVERTED,
  pendingWriteOff: CLAIM_TARIFF_STATUS.PENDING_WRITE_OFF,
  unmatched: CLAIM_TARIFF_STATUS.UNMATCHED,
  unreconciled: 'Unreconciled',
  historical: CLAIM_TARIFF_STATUS.HISTORICAL,
  writtenOff: CLAIM_TARIFF_STATUS.WRITTEN_OFF,
} as const;

// Deprecated compatibility helper for legacy statusID-based filtering paths.
export const StatusFilterMap = (status: string) => {
  switch (status) {
    case ClaimStatusEnum.ready:
      return CLAIM_TARIFF_STATUS.READY;
    case ClaimStatusEnum.incomplete:
      return CLAIM_TARIFF_STATUS.INCOMPLETE;
    case ClaimStatusEnum.error:
      return 'Error';
    case ClaimStatusEnum.submitted:
      return CLAIM_TARIFF_STATUS.SUBMITTED;
    case ClaimStatusEnum.cancelled:
      return CLAIM_TARIFF_STATUS.CANCELLED;
    case ClaimStatusEnum.pending:
      return CLAIM_TARIFF_STATUS.PENDING;
    case ClaimStatusEnum.paid:
      return CLAIM_TARIFF_STATUS.PAID;
    case ClaimStatusEnum.queried:
      return CLAIM_TARIFF_STATUS.QUERIED;
    case ClaimStatusEnum.uninsured:
      return CLAIM_TARIFF_STATUS.UNINSURED;
    case ClaimStatusEnum.invoiced:
      return CLAIM_TARIFF_STATUS.PAYOR_INVOICED;
    case ClaimStatusEnum.reverted:
      return CLAIM_TARIFF_STATUS.REVERTED;
    case ClaimStatusEnum.pendingWriteOff:
      return CLAIM_TARIFF_STATUS.PENDING_WRITE_OFF;
    case ClaimStatusEnum.writtenOff:
      return CLAIM_TARIFF_STATUS.WRITTEN_OFF;
    case ClaimStatusEnum.unmatched:
      return CLAIM_TARIFF_STATUS.UNMATCHED;
    case 'unreconciled':
      return [ClaimStatusEnum.error, ClaimStatusEnum.unreconciled];
    case ClaimStatusEnum.historical:
      return CLAIM_TARIFF_STATUS.HISTORICAL;
    case 'all':
      return Object.values(ClaimStatusEnum);
    case 'unsubmitted':
    default:
      return [
        ClaimStatusEnum.incomplete,
        ClaimStatusEnum.ready,
        ClaimStatusEnum.error,
      ];
  }
};

export const isStatus = (obj: any): obj is Status => {
  return statusSchema.safeParse(obj).success;
};
